import { GoogleCloudLogo, OciLogo } from '@/logos'
import type { ClusterProvider } from '@/graphql.types'

const providerLogos: Record<ClusterProvider, typeof OciLogo> = {
  gcp: GoogleCloudLogo,
  oci: OciLogo,
}

type Props = {
  provider: ClusterProvider
}

export const ProviderLogo = ({ provider }: Props) => {
  const Logo = providerLogos[provider]

  if (!Logo) {
    return null
  }

  return <Logo className="size-4 shrink-0" aria-hidden />
}
